export default __webpack_public_path__ + "static/media/T4-output2.b7dd5e47.png";